import { render, staticRenderFns } from "./Familiares.vue?vue&type=template&id=e27fe858"
import script from "./Familiares.vue?vue&type=script&lang=js"
export * from "./Familiares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports